<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    transition="dialog-bottom-transition"
    :overlay="false"
    @keydown.esc="closeDialog"
  >
    <v-toolbar fixed dark color="red">
      <v-toolbar-title class="pl-3">{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <v-btn
          icon
          :loading="loading"
          :disabled="loading || disablePrint"
          @click="printDialog"
          class="mr-3"
          slot="activator"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <span>Print</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn icon @click.native="closeDialog()" class="mr-3" slot="activator">
          <v-icon>close</v-icon>
        </v-btn>
        <span>Close</span>
      </v-tooltip>
    </v-toolbar>
    <v-card style="position: absolute; top: 0; left: 0;">
      <v-card-text class="my-5 pa-4">
        <v-container fill-height v-if="loading">
          <v-layout align-center justify-center>
            <v-progress-circular :size="40" :width="3" color="primary" indeterminate></v-progress-circular>
          </v-layout>
        </v-container>
        <slot v-else></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    dialog: Boolean,
    loading: Boolean,
    disablePrint: Boolean
  },
  data() {
    return {};
  },
  methods: {
    printDialog() {
      this.$emit("printDialog");
    },
    saveConfirmDialog() {
      this.$emit("saveConfirmDialog");
    },
    openDialog() {
      this.$emit("openDialog");
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style>
</style>
